import React, {
  createContext,
  useContext,
  useMemo,
  useState,
  useCallback,
  PropsWithChildren,
} from 'react';

import { IContext } from './types/context';
import { IActiveStation } from './types/activeStation';
import { TSetActiveStations } from './types/setActiveStations';

export const ActiveStationsContext = createContext({} as IContext);
export const useActiveStationsContext = () => useContext(ActiveStationsContext);

const ActiveStationsProvider = ({ children }: PropsWithChildren) => {
  const [activeStations, setActiveStations] = useState<IActiveStation[]>([]);
  const [isRouteStations, setIsRouteStations] = useState(false);
  const [bufferedActiveStations, setBufferedActiveStations] = useState<
    string[]
  >([]);

  const onSetActiveStations: TSetActiveStations = useCallback(
    (stations, isRouteStations) => {
      setActiveStations(stations);
      setIsRouteStations(!!isRouteStations);
    },
    [],
  );

  const { amountActiveStations, activeStationsCodes } = useMemo(
    () => ({
      amountActiveStations: activeStations.length,
      activeStationsCodes: activeStations.map((station) => station.code),
    }),
    [activeStations],
  );

  const value = useMemo(
    () => ({
      activeStations,
      setActiveStations: onSetActiveStations,
      amountActiveStations,
      activeStationsCodes,
      isRouteStations,
      bufferedActiveStations,
      setBufferedActiveStations,
    }),
    [
      activeStations,
      onSetActiveStations,
      amountActiveStations,
      activeStationsCodes,
      isRouteStations,
      bufferedActiveStations,
      setBufferedActiveStations,
    ],
  );

  return (
    <ActiveStationsContext.Provider value={value}>
      {children}
    </ActiveStationsContext.Provider>
  );
};

export default ActiveStationsProvider;
